export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/news-2.0e110c13-d40048.png";